import { GridColumn as Column, Grid } from '@progress/kendo-react-grid'
import { WalletDto } from 'api/Wallet/Types/Wallet'

interface StateProps {
  wallets: WalletDto[]
}

export const TransactionClientWallets: React.FC<StateProps> = ({ wallets }) => {
  return (
    <Grid
      filterable={false}
      resizable
      data={wallets}
      total={wallets.length}
      style={{ margin: '0.75rem' }}
    >
      <Column field='name' title='Name' className='table-columns__content' />
      <Column field='walletType.name' title='Wallet Type' className='table-columns__content' />
      <Column field='currency.id' title='Currency' className='table-columns__content' />
      <Column
        field='balance'
        title='Balance'
        cell={(props) => (
          <td className='table-columns__number'>{props.dataItem.balance.toFixed(2)}</td>
        )}
      />
      <Column
        field='reserved'
        title='Reserved'
        cell={(props) => (
          <td className='table-columns__number'>{props.dataItem.reserved.toFixed(2)}</td>
        )}
      />
      <Column
        field='bonusReserved'
        title='Bonus Reserved'
        cell={(props) => (
          <td className='table-columns__number'>{props.dataItem.bonusReserved.toFixed(2)}</td>
        )}
      />
      <Column
        field='pending'
        title='Pending'
        cell={(props) => (
          <td className='table-columns__number'>{props.dataItem.pending.toFixed(2)}</td>
        )}
      />
      <Column
        title='Restrictions'
        cell={(gridCellProps) => {
          return (
            <td>
              {gridCellProps.dataItem.restrictions.map(
                (restriction: { id: number; name: string }, index: number) => (
                  <p key={index}>{restriction.name},</p>
                )
              )}
            </td>
          )
        }}
      />
    </Grid>
  )
}
